import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

// Thunk for getting home banners
export const getAllDoctors = createAsyncThunk(
  "all-doctors",
  async (
    {
      category_id,
      specialization_id,
      gender_ids,
      rating_ids,
      name = "",
      sortBy,
      minprice,
      maxprice,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_DOCTORS +
          `?category_id=${category_id ||
            ""}&specialization_id=${specialization_id ||
            ""}&gender_ids=${gender_ids || ""}&rating_ids=${rating_ids ||
            ""}&name=${name || ""}&maxprice=${maxprice ||
            ""}&minprice=${minprice || ""}&sortBy=${sortBy || ""}`,
      );

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllLetestDoctor = createAsyncThunk(
  "all-doctors-letest",
  async (_, { rejectWithValue }) => {
    try {
      const Data = await GET(API.GET_LETEST_DOCTORS);

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for gettingStore
export const getDoctor = createAsyncThunk(
  "doctor",
  async (id, { rejectWithValue }) => {
    try {
      const data = await GET(API.GET_DOCTOR + `/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const checkDoctorBooking = createAsyncThunk(
  "doctor/check",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(`${API.GET_DOCTOR}/check-booking`, data);
      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      console.log("in error :", error);
      return rejectWithValue(error.response.data);
    }
  },
);
export const createDoctorAppointment = createAsyncThunk(
  "doctor/book",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(`${API.GET_DOCTOR}/book-appointment`, data);
      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      console.log("in error :", error);
      return rejectWithValue(error.response.data);
    }
  },
);

export const getAllSimilarDoctors = createAsyncThunk(
  "all-similar-doctors",
  async ({ category_id, user_id }, { rejectWithValue }) => {
    try {
      const Data = await GET(
        API.GET_ALL_SIMILAR_DOCTORS +
          `?category_id=${category_id || ""}&user_id=${user_id || ""}`,
      );

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for gettingStore
export const getDoctorSlots = createAsyncThunk(
  "doctor-slots",
  async (filter, { rejectWithValue }) => {
    try {
      const data = await GET(
        API.GET_DOCTOR +
          `/available-slots/${filter?.id}?date=${filter?.date || ""}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllAppointment = createAsyncThunk(
  "all-doctors-appointment",
  async (filter, { rejectWithValue }) => {
    try {
      const Data = await GET(
        `${API.ALL_APPOINTMENT}?page=${filter?.page || 1}`,
      );

      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const getAppointment = createAsyncThunk(
  "get-appointment",
  async (id, { rejectWithValue }) => {
    try {
      const Data = await GET(`${API.ALL_APPOINTMENT}/${id}`);

      return Data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const uploadAppointmentReport = createAsyncThunk(
  "upload-appointment-doc",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await POST(
        `${API.ALL_APPOINTMENT}/upload-report/${id}`,
        data,
      );
      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const cancelAppointmentAction = createAsyncThunk(
  "cancel-appointment",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await POST(`${API.ALL_APPOINTMENT}/cancel/${id}`, data);
      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const handleAsyncState = (state, action, isSignin = false) => {
  switch (action.type) {
    case "pending":
      state.status = "loading";
      break;
    case "fulfilled":
      state.status = "succeeded";
      if (isSignin) {
        state.token = action.payload;
        state.is_signin = true;
      }
      break;
    case "rejected":
      state.status = "failed";
      state.error = action.payload;
      if (isSignin) state.is_signin = false;
      break;
    default:
      return state;
  }
};
// Create the slice
const doctorSlice = createSlice({
  name: "doctor",
  initialState: {
    allDoctors: [],
    LatestDoctors: [],
    similarDoctors: [],
    doctor: {},
    doctorSlots: [],
    AllAppointment: [],
    singleAppointment: null,
    filters: {
      category_id: "",
      gender_id: "",
      rating_ids: [],
      gender_ids: [],
      specialization_id: [],
      min_price: 0,
      max_price: 0,
      fees_max: 0,
      sortBy: "",
    },
    error: null,
    status: "idle",
  },
  reducers: {
    setDoctorFilter: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },

    resetDoctorFilter: (state) => {
      state.filters = {
        category_id: "",
        gender_id: "",
        specialization_id: [],
        rating_ids: [],
        gender_ids: [],
        min_price: 0,
        max_price: 0,
        sortBy: "",
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAppointment.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAppointment.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.singleAppointment = action.payload.data || [];
      })
      .addCase(getAppointment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllAppointment.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllAppointment.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.AllAppointment = action.payload || [];
      })
      .addCase(getAllAppointment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllSimilarDoctors.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllSimilarDoctors.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.similarDoctors = action.payload || [];
      })
      .addCase(getAllSimilarDoctors.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllLetestDoctor.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllLetestDoctor.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.LatestDoctors = action.payload || [];
      })
      .addCase(getAllLetestDoctor.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllDoctors.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllDoctors.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allDoctors = action.payload || [];
        state.filters.fees_max = Number(action?.payload?.max_price) || 1200;
      })
      .addCase(getAllDoctors.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getDoctor.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getDoctor.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.doctor = action.payload?.data || {};
      })
      .addCase(getDoctor.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getDoctorSlots.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getDoctorSlots.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.doctorSlots = action.payload?.data || {};
      })
      .addCase(getDoctorSlots.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { setDoctorFilter, resetDoctorFilter } = doctorSlice.actions;

export default doctorSlice.reducer;
